import * as errors from "../errors.js";
import { state } from "../state.js";

/*
    The numerical function ATN is a mathematical function that returns the arc tangent of a numeric value (the inverse function of TAN). 
    The resulting value is the angle in radians of the given tangent. If the term given in the parentheses is non-numerical, the BASIC 
    error ?TYPE MISMATCH ERROR occurrs. If the argument expression is not in the range of a floating point value the execution yields 
    the BASIC error ?OVERFLOW ERROR. Omitting the numeric argument or to many arguments results in a ?SYNTAX ERROR.
*/
export const atn = async (args) => {
    // If no args are given, throw a syntax error.
    if (args.length === 0) {
        throw new errors.SyntaxError();
    }

    // Check if the args is a number.
    if (isNaN(args)) {
        throw new errors.TypeMismatchError();
    }

    if (Math.abs(args) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Calculate the arc tangent.
    const result = Math.atan(args);

    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Return the result.
    return result;
};